module.exports = __webpack_public_path__ + "static/media/BIFI-BNB.25b6adf5.svg";